import classNames from 'classnames'
import { useState, type ReactElement } from 'react'
import { Controller } from 'react-hook-form'
import { MdStar, MdStarBorder } from 'react-icons/md'

import type { Props as WrapperProps } from '../Wrapper'
import type { Control } from 'react-hook-form'

import Wrapper from '../Wrapper'

import './styles.scss'

interface Props extends WrapperProps {
  control: Control<any, any, any>
  defaultValue?: number
  legend?: {
    end: string
    start: string
  }
  maxValue?: number
  name: string
}

const StarRatingInput = ({
  className,
  control,
  defaultValue = 0,
  error,
  legend = { end: 'Very satisfied', start: 'Not satisfied' },
  maxValue = 5,
  name,
}: Props): ReactElement => {
  const [hoveredStar, setHoveredStar] = useState(0)

  return (
    <Wrapper className={classNames('star-rating-input-component', className)} error={error}>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value } }) => (
          <>
            <div className="star-rating-input-component__stars">
              {[...Array(maxValue)].map((_, index) => {
                const starValue = index + 1

                return (
                  <span
                    key={index}
                    onClick={() => onChange(starValue === value ? 0 : starValue)}
                    onMouseEnter={() => setHoveredStar(starValue)}
                    onMouseLeave={() => setHoveredStar(0)}
                  >
                    {starValue <= (hoveredStar || value) ? (
                      <MdStar color="#fdbf4e" size={40} />
                    ) : (
                      <MdStarBorder size={40} />
                    )}
                  </span>
                )
              })}
            </div>
            <div className="star-rating-input-component__legend">
              <span>{legend.start}</span>
              <span>{legend.end}</span>
            </div>
          </>
        )}
      />
    </Wrapper>
  )
}

export default StarRatingInput
